// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__1vNbI","inputWrap":"Table_inputWrap__39PAO","col":"Table_col__1aiFj","bmiTooltip":"Table_bmiTooltip__15zBy"};